export const minusIcon = () => {
    return (
        <svg  width="30"  height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="var( --dark-semi)"  strokeWidth="1"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-minus">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l14 0"
            fill="var(--dark)" />
               
        
        </svg>
    )
}